module.exports = __webpack_public_path__ + "img/ic_feedback_sel.b615ab58.svg";